import { computed, ref } from "vue";
import { useCAdsetsStore } from "@stores/cAdsets";
import { useCCampaignsStore } from "@stores/cCampaigns";

const selectedIds = ref(new Set());

const isSelected = (id) => selectedIds.value.has(id);

const toggleSelection = (id) => {
  const next = new Set(selectedIds.value);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  selectedIds.value = next;
};

const setSelection = (ids) => {
  selectedIds.value = new Set(ids);
};

const clearSelection = () => {
  selectedIds.value = new Set();
};

const selectedCount = computed(() => selectedIds.value.size);

const propagate = (sourceId, attribute, value) => {
  const { cAdsets, isCAdsetVisible } = useCAdsetsStore();
  const { cCampaigns } = useCCampaignsStore();
  const sourceAdset = cAdsets.find((a) => a.id === sourceId);
  if (!sourceAdset) return;

  const shouldPropagate = selectedIds.value.has(sourceId) && isCAdsetVisible(sourceAdset);
  const targetIds = shouldPropagate ? [...selectedIds.value] : [sourceId];

  const inactiveGroups = new Set(
    cCampaigns.filter((cc) => cc.status !== "active").map((cc) => cc.group_token),
  );

  targetIds.forEach((id) => {
    const adset = cAdsets.find((a) => a.id === id);
    if (!adset) return;
    if (attribute === "status" && inactiveGroups.has(adset.group_token)) return;
    adset[attribute] = value;
    if (attribute === "daily_budget") adset.daily_budget_initial = value;
  });
};

export const useBudgetSelection = () => ({
  selectedIds,
  isSelected,
  toggleSelection,
  setSelection,
  clearSelection,
  selectedCount,
  propagate,
});
